// Resolves a redux-style API slice ({ isProcessing, data, error }) into one of
// three section outcomes, so every chart/section can share the same "hide the
// whole thing when there's no data" behaviour instead of showing a "No data" box.
export const SECTION = {
    LOADING: 'loading',
    READY: 'ready',
    HIDDEN: 'hidden',
};

// Default emptiness check: null/undefined, an empty array, or an empty object.
// Sections with a different shape (e.g. "all values are 0") pass their own.
export const defaultIsEmpty = (data) =>
    data == null ||
    (Array.isArray(data) && data.length === 0) ||
    (typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length === 0);

export const sectionState = (api, isEmpty = defaultIsEmpty) => {
    if (!api || api.isProcessing) return SECTION.LOADING;
    if (api.error || isEmpty(api.data)) return SECTION.HIDDEN;
    // Some sections come wrapped with a `scope` envelope (e.g. leader-count
    // gating) — only render when that scope explicitly says it isn't gated.
    if (api.data && api.data.scope && api.data.scope.gated) return SECTION.HIDDEN;
    return SECTION.READY;
};
